export enum UnderlyingsEnum {
  BBSW = 'BBSW',
  BUBO = 'BUBO',
  BSKT = 'BSKT',
  CDOR = 'CDOR',
  CIBO = 'CIBO',
  CZNA = 'CZNA',
  EFFR = 'EFFR',
  EONA = 'EONA',
  EONS = 'EONS',
  ESTR = 'ESTR',
  EURI = 'EURI',
  EUUS = 'EUUS',
  EUCH = 'EUCH',
  FUSW = 'FUSW',
  GCFR = 'GCFR',
  ISDA = 'ISDA',
  JIBA = 'JIBA',
  LIBI = 'LIBI',
  LIBO = 'LIBO',
  MAAA = 'MAAA',
  MOSP = 'MOSP',
  NIBO = 'NIBO',
  OBFR = 'OBFR',
  PFAN = 'PFAN',
  PRBO = 'PRBO',
  STBO = 'STBO',
  SWAP = 'SWAP',
  TIBO = 'TIBO',
  TLBO = 'TLBO',
  TONA = 'TONA',
  TREA = 'TREA',
  WIBO = 'WIBO',
}

export enum UnderlyingSelectEnum {
  identifier = 'Identifier',
  name = 'Name',
  isin = 'ISIN',
  basket = 'Basket',
}
